import type { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { UpsellGlpButton, UpsellGlpHeader } from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface GlpHeaderBlockProps {
  block: UpsellGlpHeader
}

export const GlpHeaderBlock: FC<GlpHeaderBlockProps> = ({ block }) => {
  if (!block) {
    return null
  }

  return (
    <Box className="mx-auto" alignItems="center" textAlign="center" gap="s16" maxWidth="s600">
      {block?.sectionTitle && (
        <Text size="700" color="black" weight="bold">
          {block?.sectionTitle || ''}
        </Text>
      )}
      {block?.sectionSubtitle && (
        <Text size="400" className="mb-4">
          {block?.sectionSubtitle || ''}
        </Text>
      )}

      <Box gap="s16" flexDirection="row" justifyContent="center">
        {block?.actions &&
          block?.actions?.map((action: UpsellGlpButton) => (
            <F0Button
              key={action?.id}
              label={action?.label}
              variant={action?.style == 'primary_btn' ? 'default' : 'outline'}
              onClick={() => {
                track(trackingEvents.discover.clickGlpButton, {
                  component: 'glp_header_section',
                  action: action.label,
                })
                if (action?.opensInNewTab) {
                  window.open(action?.url, '_blank')
                } else {
                  window.location.href = action?.url
                }
              }}
            />
          ))}
      </Box>
    </Box>
  )
}
